import { FC, useState } from 'react';
// import { Table, Typography } from 'antd';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import { customerNegativeHistory } from '@/libs/fleet-api/services/prospect';

export type NegativeHistoryModalState = null | {
	customerNegativeHistory: customerNegativeHistory;
};

export type NegativeHistoryModalProps = {
	modal: NegativeHistoryModalState;
	onClose: () => void;
};

const NegativeHistoryModal: FC<NegativeHistoryModalProps> = ({
	modal,
	onClose,
}) => {
	const {
		customerName,
		isActive,
		negativeDate,
		// negativeId,
		// negativeStatus,
		negativeType,
		// nonegativeId,
		prospectId,
		source,
		lastSktDate,
		notes,
		skt,
	} = modal?.customerNegativeHistory ?? {};

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<div style={{ textAlign: 'center' }}>
				<svg
					width="36"
					height="36"
					viewBox="0 0 36 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.9751 0C27.917 0 36 8.08301 36 18.0249C36 27.9668 27.917 36 17.9751 36C8.0332 36 0 27.9668 0 18.0249C0 8.08301 8.0332 0 17.9751 0ZM17.7743 6.62739C17.2714 7.22988 17.0208 7.93359 17.0208 8.6855C17.0208 9.28799 17.2216 9.79087 17.5236 10.1411C17.8755 10.493 18.3768 10.6938 18.8796 10.6938C19.5833 10.6938 20.2356 10.3918 20.7369 9.78926C21.1884 9.23658 21.4406 8.43326 21.4406 7.58013C21.4406 7.07725 21.2896 6.62579 20.9377 6.27393C20.5859 5.92208 20.0846 5.72125 19.5817 5.72125C18.9294 5.72125 18.2755 6.0233 17.7743 6.62579V6.62739ZM13.205 17.0208L13.8075 17.673C14.2589 17.1702 14.712 16.7685 15.0124 16.5179C15.3145 16.317 15.5651 16.2158 15.766 16.2158C15.917 16.2158 16.068 16.2656 16.1676 16.3669C16.2174 16.5179 16.2688 16.6689 16.2688 16.9195C16.2688 18.1743 16.1178 18.9776 15.4655 21.9901C14.8132 25.0025 14.4614 27.2117 14.4614 28.6673C14.4614 29.22 14.5626 29.6216 14.7634 29.8723C14.9144 30.1229 15.2149 30.3237 15.6165 30.3237C16.2688 30.3237 17.2232 29.8209 18.3286 28.9677C19.4339 28.0632 20.5377 26.8084 21.7427 25.2018L21.0904 24.6491C20.6887 25.152 20.2871 25.5022 19.985 25.7545C19.683 25.9553 19.4323 26.1561 19.2315 26.1561C19.0805 26.1561 18.9294 26.0051 18.8298 25.9055C18.78 25.7545 18.7286 25.5536 18.7286 25.2532C18.7286 25.0524 18.7784 24.4001 18.9792 23.2449C19.1303 22.0897 19.0805 22.0897 19.3809 20.3835C19.4307 19.8806 19.5817 19.1785 19.7328 18.3253C20.1344 15.7644 20.3851 14.2075 20.3851 13.7063C20.3851 13.2548 20.234 12.8531 20.083 12.6009C19.8822 12.3502 19.5801 12.249 19.2299 12.249C18.6274 12.249 17.8241 12.7005 16.7187 13.5038C15.6133 14.3569 14.5096 15.5121 13.2034 17.0191L13.205 17.0208Z"
						fill="#1557BC"
					/>
				</svg>
				<h3
					style={{
						fontSize: 23,
						marginTop: 10,
						marginBottom: 30,
					}}
				>
					Negative Detail
				</h3>
			</div>

			<DataRow
				items={[
					[
						['Customer Name', customerName],
						['Prospect ID', prospectId],
					],
					[
						['FBDH Name', '-'],
						['FRM Name', '-'],
					],
					[
						['Division', '-'],
						['Sumber Order', '-'],
					],
					[
						['Reject Date', negativeDate],
						['Data Source', source],
					],
					[
						['Bad Type', negativeType],
						['Still Active', isActive],
					],
					[
						['SKT', skt],
						['Last SKT Date', lastSktDate],
					],
					[['Negative Notes', notes]],
				]}
			/>
		</FleetModal>
	);
};

export default NegativeHistoryModal;

export const useNegativeHistoryModal = () => {
	return useState<NegativeHistoryModalState>(null);
};
